import React, { useState } from 'react'
import styled from 'styled-components'

import { Icon, Fonts } from 'components/base-ui'
import { Card, IconPaymentWrapper } from './styles'
import { useTranslation } from 'react-i18next'

import CreditCardDetails from './CreditCardDetails'
import { CreditCardType } from 'types/payment'
import { LabelMedium, LinkSmall } from 'components/base-ui/FontsV2'

interface ListCardCreditCardProps {
  isActivePaymentMethod: boolean
  selectedCreditCard: CreditCardType
  listCreditCards: CreditCardType[]
  onClickAddNewCreditCard: () => void
  onClickSelectCreditCard: (creditCard: CreditCardType) => void
  onClickEditCreditCard: (creditCard: CreditCardType) => void
}

const ListCardCreditCard: React.FC<ListCardCreditCardProps> = ({
  isActivePaymentMethod,
  listCreditCards,
  onClickAddNewCreditCard,
  onClickSelectCreditCard,
  onClickEditCreditCard,
  selectedCreditCard,
}) => {
  const { t } = useTranslation()

  const [isOpenCollapse, setIsOpenCollapse] = useState<boolean>(false)
  const isHaveSelectCreditCard = true
  const isHaveCreditCard = listCreditCards.length > 0
  const _selectedCreditCard = selectedCreditCard ? selectedCreditCard : null

  return (
    <>
      <CardCollapse
        id="payment-type-credit"
        className={`
            ${_selectedCreditCard && !isOpenCollapse && isActivePaymentMethod ? '-active' : ''}
            ${isOpenCollapse || !_selectedCreditCard ? ' -hide-active' : ''}
          `}
        onClick={(e) => {
          if (!isHaveSelectCreditCard || isOpenCollapse || isActivePaymentMethod || !_selectedCreditCard) {
            toggleCollapse(e)
          } else if (isHaveCreditCard && _selectedCreditCard) {
            onClickSelectCreditCard(_selectedCreditCard)
          }
        }}
      >
        <IconPaymentWrapper>
          <Icon name="credit-card" size="14px" />
        </IconPaymentWrapper>
        {t('creditCard')}
        {_selectedCreditCard && !isOpenCollapse ? ` ***${_selectedCreditCard.cardLastDigits}` : ''}
        <BtnCollapse onClick={toggleCollapse}>
          <IconCollapse name="caret-right" isOpen={isOpenCollapse} />
        </BtnCollapse>
      </CardCollapse>

      {isOpenCollapse && (
        <>
          {listCreditCards.map((card, i) => (
            <SubCard
              key={i}
              onClick={(e) => {
                e.stopPropagation()
                onClickSelectCreditCard(card)
              }}
              className={`credit-cart-item ${
                selectedCreditCard?.cardID === card.cardID && isActivePaymentMethod ? '-active' : ''
              }`}
            >
              <LabelMedium noWrap>
                <CreditCardDetails {...card} />
              </LabelMedium>
              <BtnEditCreditCard>
                <LinkSmall
                  noWrap
                  color="primary"
                  onClick={(e) => {
                    e.stopPropagation()
                    onClickEditCreditCard(card)
                  }}
                >
                  {t('paymentMethodPage.creditCard.remove')}
                </LinkSmall>
              </BtnEditCreditCard>
            </SubCard>
          ))}

          {listCreditCards.length < 5 && (
            <CardAddCreditCard onClick={onClickAddNewCreditCard}>
              <Fonts.ActionBaseBold>{t('paymentMethodPage.button.addNewCreditCard')}</Fonts.ActionBaseBold>
            </CardAddCreditCard>
          )}
        </>
      )}
    </>
  )

  function toggleCollapse(e) {
    e.stopPropagation()
    setIsOpenCollapse((value) => {
      return !value
    })
  }
}

export default ListCardCreditCard

const CardCollapse = styled(Card)`
  padding: ${({ theme }) => theme.spacing.XL};
  padding-right: ${({ theme }) => theme.spacing['9XL']};
  white-space: nowrap;

  &.-hide-active {
    padding-right: 8px;

    &::after {
      display: none !important;
    }
  }

  &.-active {
    &::after {
      display: flex !important;
    }
  }
`

const SubCard = styled(Card)`
  padding-right: ${({ theme }) => `calc(${theme.spacing.XL} + ${theme.spacing.XS} + 24px)`};
`

const CardAddCreditCard = styled(Card)`
  justify-content: center;
  color: ${({ theme }) => theme.colors.primary};

  &::after {
    display: none !important;
  }
`

const BtnCollapse = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
`

const BtnEditCreditCard = styled.div`
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;
  color: ${({ theme }) => theme.colors.primary};

  ${Fonts.LinkSmall} {
    font-weight: ${Fonts.weight.medium} !important;
  }
`

const IconCollapse = styled(Icon)<{ isOpen: boolean }>`
  color: ${({ theme }) => theme.colors.primary};
  font-size: 12px;

  transform: rotate(90deg);

  ${({ isOpen }) =>
    isOpen &&
    `
    transform: rotate(-90deg);
  `}
`
